import { UserState } from './ducks';

const getRootUserState = (state): UserState => state.user;

export const getUser = getRootUserState;

export const isUserLoggedIn = (state?: UserState): boolean => state?.token != null;
